import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import PageSEO from "@/components/PageSEO";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { http.get("/faq").then(r => setFaqs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageSEO
        title="Investor FAQ – Common Questions About Mayoto"
        description="Answers to common questions about Mayoto's investment structure, minimum amounts, returns, security, KYC, referrals and how the platform works."
        canonicalPath="/faq"
        jsonLd={faqs.length ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(f => ({
            "@type": "Question",
            "name": f.question,
            "acceptedAnswer": { "@type": "Answer", "text": f.answer }
          }))
        } : null}
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">FREQUENTLY ASKED</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="faq-title">
            Questions, answered clearly.
          </h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={`item-${i}`} className="border border-slate-200 rounded-2xl px-6 data-[state=open]:bg-slate-50">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="font-display font-bold text-left text-[#0a1128] hover:no-underline">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed" data-testid={`faq-a-${i}`}>
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
